import {
  LOAD_ECOMMERCE_SETUP_FAIL,
  LOAD_ECOMMERCE_SETUP_SUCCESS,
  LOAD_ECOMMERCE_SETUP_LIST,
  EcommerceSetupListAction,
  LoadEcommerceSetupListFails,
  LoadEcommerceSetupListSuccess,
  LoadEcommerceSetupList
} from "../actions";

export interface IEcommerceSetupListEntityState {
    list: any;
    loading: boolean;
    loaded: boolean;
}

export interface IEcommerceSetupListState {
    list: any;
    loading: boolean;
    loaded: boolean;
}

export const initialState: IEcommerceSetupListState = {
    list: null,
    loading: false,
    loaded: false
};

export function reducer(state: IEcommerceSetupListState = initialState, action: EcommerceSetupListAction): IEcommerceSetupListState {
  let payload: any;
  switch (action.type) {

    case  LOAD_ECOMMERCE_SETUP_LIST:
      payload = (<LoadEcommerceSetupList>action).payload;
      return {
        ...state,
        loading: true,
        loaded: false
      };

    case LOAD_ECOMMERCE_SETUP_SUCCESS:
      payload = (<LoadEcommerceSetupListSuccess>action).payload;
      return {
        ...state,
        list: payload,
        loading: false,
        loaded: true
      };

    case  LOAD_ECOMMERCE_SETUP_FAIL:
      payload = (<LoadEcommerceSetupListFails>action).payload;
      return {
        ...state,
        loading: false,
        loaded: true
      };
  }

  return state;
}
